import {FC, useMemo} from 'react'
import {ColumnDef} from '@tanstack/react-table'
import {Badge, Card} from 'react-bootstrap'
import DataTable from '../../../../../ui-kit/DataTable'
import {getISO2ByISO3, getNameByISO3, shortenLargeNumber} from '../../../../libs/misc'
import {DIVERTED_TABLE_IDX, SimulationResponse} from '../core/_models'

type Row = {econ: string; gain: number}

const IncreasedExportsTable: FC<{
  result: SimulationResponse
  onBadgeClick: (econ: string) => void
}> = ({result, onBadgeClick}) => {
  const counter = result.partners_affected.diverted_to_detail_data?.counter || {}
  const rows: Row[] = useMemo(
    () =>
      (result.partners_affected.diverted_to_table_data || []).map((r) => ({
        econ: r[DIVERTED_TABLE_IDX.econ],
        gain: r[DIVERTED_TABLE_IDX.gainAmount],
      })),
    [result]
  )

  const columns: ColumnDef<Row, any>[] = [
    {
      accessorKey: 'econ',
      header: 'Economy',
      cell: (c) => (
        <>
          <span
            className={`fi fi-${(getISO2ByISO3(c.getValue()) || '').toLowerCase()} me-2`}
          ></span>
          {getNameByISO3(c.getValue())}
        </>
      ),
    },
    {
      accessorKey: 'gain',
      header: 'Increased exports',
      cell: (c) => <span className='kt-font-success'>{shortenLargeNumber(c.getValue())}</span>,
    },
    {
      id: 'detail',
      header: 'Details',
      enableSorting: false,
      cell: (c) => {
        const econ = c.row.original.econ
        const [, commodities, economies] = counter[econ] || [0, 0, 0]
        return (
          <Badge bg='info' className='cursor-pointer text-white' onClick={() => onBadgeClick(econ)}>
            {commodities} commodities / {economies} economies
          </Badge>
        )
      },
    },
  ]

  return (
    <Card className='mb-5'>
      <Card.Header className='card-header-stretch'>
        <Card.Title>
          <h3>Increased exports by other economies (trade diversion)</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <DataTable
          data={rows}
          columns={columns}
          enablePagination={rows.length > 25}
          initialSortBy={{id: 'gain', desc: true}}
        />
      </Card.Body>
    </Card>
  )
}

export default IncreasedExportsTable
